import React from 'react';

import BlogViewerDialog from './viewer/BlogViewerDialog'
import ContentsHeader from './ContentsHeader';
import ImageUploader from '../common/Util/ImageUploader';

// tag input
import { WithContext as ReactTags } from 'react-tag-input';
import '../common/Util/TagStyle.css';

// http axios
import axios from 'axios';
import axiosUrl from '../../axios/url';

// summernote
import ReactSummernote from "react-summernote";
import "react-summernote/dist/react-summernote.css";
import "react-summernote/lang/summernote-ko-KR";
import "bootstrap/js/modal";
import "bootstrap/js/dropdown";
import "bootstrap/js/tooltip";





export default function BlogsModify(prop) {

    const [contentId , setContentId] = React.useState('');       // 콘텐츠 아이디
    const [title , setTitle] = React.useState('');               // 제목
    const [body , setBody] = React.useState('');                 // 내용
    const [opened , setOpened] = React.useState(false);          // 공개여부
    const [thumbnailUrl , setThumbnailUrl] = React.useState(''); // 썸네일 이미지 경로
    const [keyword , setKeyword] = React.useState([]);           // 검색어
    const [reference, setReference] = React.useState('');        // 참고문헌
    const [type, setType] = React.useState('BLOG');              // 콘텐츠 유형 
    const [updatedAt, setUpdatedAt] = React.useState(''); 
    const [oldThumbImage, setOldThumbImage] = React.useState(''); 

    const KeyCodes = {
        comma: 188,
        enter: 13,
      };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
      
      
    //----- setter
    function onChangeTitle(e){ setTitle(e.target.value);}
    function onChangeBody(editorHTML){ setBody(editorHTML); }
    function onChangeOpened(e){ setOpened(e.target.checked);}
    function handleKeywordDelete(i) {  setKeyword(keyword.filter((tag, index) => index !== i)); }
    function handleKeywordAddition(tag) {  setKeyword([...keyword, {id :tag.text, text:tag.text}]); }
    function onChangeReference(e){ setReference(e.target.value);}



    // 썸네일 이미지 변경
    function onChangeThumbFile(imageFile){
        var formData = new FormData();
        formData.append('file', imageFile[0])
        return axios.post(axiosUrl.fileupload, formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Max-Age': '3600',
            'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
        }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            setThumbnailUrl(res.data.filename);
        }).catch( e => {
                console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
        })
    }


    function sendFile(images, insertImage) {

        let obj  = new Image();
        obj = images[0];


        var formData = new FormData();
        formData.append("file", images[0]);
        return axios.post(axiosUrl.fileupload, formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Max-Age': '3600',
            'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
        }).then(res => {
            
            let resize = 'style="width: 100%;"';
            //if(obj.size > 200000)  resize = 'style="width: 100%;"';
            //else  resize = 'style="width: 100%;"';
            
            const fullname = '<img src="'+ res.data.filename +  '" '+resize+' />';

            setBody(body.concat(fullname));

            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.sendFile SUCCESS');
        }).catch( e => {
             console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.sendFile - ' + e.response.data.error.message);
        })
    }

    // 해당 콘텐츠 삭제
    async function deleteContent(e){
        if(!window.confirm('해당 콘텐츠를 삭제하시겠습니까?')) return;

        var url = axiosUrl.blogs + '/' + contentId;
        await axios.delete(url)
        .then(function (response){ 
            alert('콘텐츠가 삭제되었습니다.');
            goContentsList(); 
        })
        .catch(function (e) {
            alert('콘텐츠가 삭제에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] blogsmodify.deleteContent - ' + e);
        });

    }

    // 콘텐츠 목록으로 이동
    function goContentsList(){
        window.location = '/contents';
    }


    // 콘텐츠 정보 가져오기
    async function getContent(id){
        var url = axiosUrl.blogs + '/' + id;
        await axios.get(url)
        .then( res => {
           setTitle(res.data.title);
           setBody(res.data.blog.body);
           setOpened(res.data.opened);

           // keyword 데이터 타입 맞추기
           if(res.data.keyword !== ''){

                const resultArr = res.data.keyword .split(",");
                const tagArr = [];
                resultArr.map((tagName, i) => {
                    tagArr.push({id: tagName, text: tagName});
                })
                setKeyword(tagArr);
           }else{
                setKeyword([]);
           }

           setReference(res.data.reference);
           setThumbnailUrl(res.data.thumbnailUrl);
           setOldThumbImage(res.data.thumbnailUrl);
        })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.getProgram - ' + e);
        });
    }

    // 에디터 이미지 파일을 base64 형식으로 인코딩해 이미지 파일의 모든 크기가 db에 insert됨.
    function onImageUpload(images, insertImage){
        for (let i = 0; i < images.length; i++) {
            const reader = new FileReader();
      
            reader.onloadend = () => {
              insertImage(reader.result);
            };
      
            reader.readAsDataURL(images[i]);
          }
    }

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }
 
    // 콘텐츠 정보 저장
    async function saveContent(e){
        if(trim(title) === ''){ alert('제목을 확인하세요.'); return;}
        if(trim(body) === ''){ alert('콘텐츠 내용을 확인하세요.'); return;}


        //if(!window.confirm('작성중인 콘텐츠 정보를 변경하시겠습니까?')) return;

        var tagString = "" ;
        keyword.map((tag, i) => {
            if( i === 0) {
                tagString = tagString + tag.text;
            } else {
                tagString = tagString +","+ tag.text;
            }
        })

        const param = {
            "type": type,
            "title": title,
            "keyword": tagString,
            "reference": reference,
            "thumbnailUrl": thumbnailUrl,
            "opened": opened,
            "blog":{"body" : body}
        }


        var url = axiosUrl.blogs + '/' + contentId;
        await axios.put(url,param,{
            headers: {
            'Content-Type': 'application/json',
        }
        }).then( res => {
            alert('콘텐츠가 변경되었습니다.');
            console.log('[MEDIEX_CMS_2019_LOGGING] ProgramEditDialog.saveContent - SUCCESS');
            goContentsList();
        }).catch(function (e) {
            alert('콘텐츠가 변경에 실패하였습니다 .다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.saveContent - ' + e);
        });
    }

    function getTimeStamp() {
        var d = new Date();
      
        var s =
          leadingZeros(d.getFullYear(), 4) + '-' +
          leadingZeros(d.getMonth() + 1, 2) + '-' +
          leadingZeros(d.getDate(), 2) + ' ' +
      
          leadingZeros(d.getHours(), 2) + ':' +
          leadingZeros(d.getMinutes(), 2) + ':' +
          leadingZeros(d.getSeconds(), 2);
      
        return s;
      }
      
      
      
    function leadingZeros(n, digits) {
        var zero = '';
        n = n.toString();
      
        if (n.length < digits) {
          for (var i = 0; i < digits - n.length; i++)
            zero += '0';
        }
        return zero + n;
    }


    React.useEffect(() => {
        setContentId(prop.match.params.id);
        getContent(prop.match.params.id);

        setUpdatedAt(getTimeStamp()); // 현재 날짜시간으로 업데이트 일시 세팅
    },[prop.match.params.id]);

    return(
        <div >
            <div className="content-wrapper">
                
                <ContentsHeader  />
                
                <section className="content" >
                    <div className="row">
                            <div className="col-6">
                                <div className="card">
                                    <div className="card-header contentColor">
                                        <h3 className="card-title">기본정보</h3>
                                    </div>
                                    <div className="card-body">
                                        <input type="text" className="form-control" id="title11" placeholder="제목을 입력하세요.." onChange={onChangeTitle}  value={title} />
                                    </div>

                                    <div className="card-body">
                                        <ReactSummernote
                                            value={body}
                                            placeholder="내용을 입력하여주세요"
                                            options={{
                                            lang: "ko-KR",
                                            height: 562,
                                            dialogsInBody: true,
                                            toolbar: [
                                                        ["style", ["style"]],
                                                        ["font", ["bold", "underline", "clear"]],
                                                        ["fontname", ["fontname"]],
                                                        ["para", ["ul", "ol", "paragraph"]],
                                                        ["table", ["table"]],
                                                        ["insert", ["picture"]],
                                                        ["view", ["fullscreen", 'codeview']],
                                                    ]
                                            }}
                                            onChange={onChangeBody}
                                            onImageUpload={sendFile}
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="col-6">
                                 <div className="card card-danger">
                                    <div className="card-header contentColor">
                                        <h3 className="card-title">공개여부</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="custom-control custom-switch">
                                            <input type="checkbox" className="custom-control-input" id="customSwitch1" onChange={onChangeOpened} checked={opened} />
                                            <label className="custom-control-label" htmlFor="customSwitch1">공개</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header contentColor">
                                        <h3 className="card-title">썸네일</h3>
                                    </div>
                                    {
                                        oldThumbImage !== '' && <div className="card-body text-center mb-0"><img src={oldThumbImage} width="150" height="150"/></div>
                                    }
                                    <div className="card-body ">
                                        <ImageUploader  callbackImage={onChangeThumbFile} imageName={thumbnailUrl} />
                                    </div>
                                </div>


                                <div className="card">
                                    <div className="card-header contentColor">
                                        <h3 className="card-title">검색어</h3>
                                    </div>
                                    <div className="card-body">
                                        <ReactTags id="keywordTag"
                                            tags={keyword}
                                            placeholder='검색어'
                                            handleDelete={handleKeywordDelete}
                                            handleAddition={handleKeywordAddition}
                                            autofocus={false}
                                            readOnly={false}
                                            delimiters={delimiters}
                                        />
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header contentColor">
                                        <h3 className="card-title">참고문헌</h3>
                                    </div>
                                    <div className="card-body">
                                        <input type="text" className="form-control" id="title" placeholder="내용을 입력하세요.." onChange={onChangeReference} value={reference} />
                                    </div>
        
                                </div>

                                <div className="button-wrapper mb-5 col-12"  >
                                    <a data-toggle="modal" data-target="#BlogViewerDialog" ><button type="button" className="btn btn-primary" ><i className="fas fas fa-search"></i>미리보기</button></a>
                                    <button onClick={saveContent} type="button" className="btn btn-primary mr-1"><i className="fas fa-edit"></i> 저장하기</button>
                                    <button onClick={deleteContent} type="button" className="btn btn-danger  mr-1"><i className="fas fa-trash-alt"></i> 삭제</button>
                                    <button onClick={goContentsList} type="button" className="btn btn-primary"><i className="fas fa-list"></i> 목록</button>
                                </div>
                            </div>
                        </div>

                </section>
                <BlogViewerDialog id={prop.match.params.id} />
             </div>
        </div>
    );
}